import { ToolCard } from "./ToolCard";
import type { Ferramenta } from "@/constants/ferramentas";

interface ToolsGridProps {
  ferramentas: Ferramenta[];
}

export const ToolsGrid = ({ ferramentas }: ToolsGridProps) => {
  return (
    <section className="mb-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {ferramentas.map((ferramenta, index) => (
          <ToolCard key={ferramenta.id} ferramenta={ferramenta} index={index} />
        ))}
      </div>
    </section>
  );
};
